// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/outline_combine.fragment.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'outline_combinePixelShader';
const shader = `#define MAX_COLORS 10
varying vec2 vUV;
uniform sampler2D textureSampler;
uniform vec4 colors[MAX_COLORS];
uniform vec2 uvScale;
uniform vec2 halfSourcePixelSize;
float remap(float x, float old_min, float old_max, float new_min, float new_max)
{
return (x - old_min) / (old_max - old_min) * (new_max - new_min) + new_min;
}
void main(void) {
vec2 uv = vUV * uvScale;
vec4 value = texture2D(textureSampler, uv);
int index = int(remap(value.r, 1./float(MAX_COLORS + 1), 1., 0., float(MAX_COLORS)) + 0.5) - 1;
vec4 color;
if (index >= 0) {
for(int i = 0; i < MAX_COLORS; i++) {
if(i == index) {
color = colors[i];
break;
}
}
float width = 0.2 - 0.2 * value.b;
float inside;
inside  = texture2D(textureSampler, uv + halfSourcePixelSize * vec2(-1, -1)).g;
inside += texture2D(textureSampler, uv + halfSourcePixelSize * vec2(-1, 1)).g;
inside += texture2D(textureSampler, uv + halfSourcePixelSize * vec2(1, 1)).g;
inside += texture2D(textureSampler, uv + halfSourcePixelSize * vec2(1, -1)).g;
inside /= 4.0;
float gradient = value.a;
float alpha = smoothstep(width, width + 0.15, gradient) - inside;
gl_FragColor = vec4(color.rgb, max(0.0, alpha * color.a));
} else {
gl_FragColor = vec4(0, 0, 0, 0);
}
}`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const outline_combinePixelShader = { name, shader };
//# sourceMappingURL=outline_combine.fragment.js.map